<template>
	<div class="divide-y-2 divide-gray-200">
		<!-- Date -->
		<offer-edit-date :form="form" class="p-6" />

		<!-- Contract Terms -->
		<offer-edit-extra
			:form="form"
			:is-extra-required="isExtraRequired"
			class="p-6 space-y-6"
			v-if="form.trade == 'BUY'"
			:user="user"
		/>

		<div v-else>
			<ui-textarea-group
				class="p-4"
				v-model="form.extra.text"
				field="extra.text"
				label="Additional terms relevant to the contract"
				tooltip-text="Additions to contract-relevant characteristics with regard to quality, deadline, loading or other. Will be printed on the contract."
				:form="form"
				:required="false"
			/>
			<ui-check-group
				class="p-4"
				v-model="form.variety_protection_enabled"
				field="variety_protection_enabled"
				label="EU Plant Variety Protection"
				:tooltip-text="euVarietyProtectionInfo"
				:form="form"
				:disabled="user.type == 'FARMER'"
			></ui-check-group>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
	},
	computed: {
		isExtraRequired() {
			return this.form.trade == "BUY" ? true : false;
		},
		euVarietyProtectionInfo: function () {
			return this.__("eu_variety_protection_info");
		},
	},
};
</script>
